import { apiClient } from './apiClient';
import type { Notification } from '@/types';

export const notificationService = {
  async list(filter?: string): Promise<Notification[]> {
    const { data } = await apiClient.get<Notification[]>('/notifications',
      { params: filter && filter !== 'all' ? { filter } : undefined });
    return data;
  },

  async markAsRead(id: string): Promise<void> {
    await apiClient.patch(`/notifications/${id}/read`);
  },

  async markAllAsRead(): Promise<void> {
    await apiClient.patch('/notifications/read-all');
  },

  async getUnreadCount(): Promise<number> {
    const { data } = await apiClient.get<{ count: number }>('/notifications/unread-count');
    return data.count;
  },
};
